import styled from '@emotion/styled'

interface LoadingSpinnerProps {
  color?: string
  size?: 'sm' | 'default'
}

export const LoadingSpinner = styled.div<{ size: 'sm' | 'default' }>`
  line-height: 1;
  margin-top: ${({ size }) => (size === 'sm' ? '0px' : '12px')};
  margin-bottom: ${({ size }) => (size === 'sm' ? '0px' : '12px')};
  @keyframes loader-anim {
    0% {
      stroke-dashoffset: 240;
      transform: rotate(0);
      stroke-width: 8;
    }
    50% {
      stroke-dashoffset: 76;
      transform: rotate(45deg);
      stroke-width: 10;
    }
    100% {
      stroke-dashoffset: 240;
      transform: rotate(360deg);
      stroke-width: 8;
    }
  }
  @keyframes svg-anim {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }
`

export const LoadingSVG = styled.svg<{ size: 'sm' | 'default' }>`
  width: ${({ size }) => (size === 'sm' ? '24px' : '64px')};
  height: ${({ size }) => (size === 'sm' ? '24px' : '64px')};
  animation: 2s linear infinite svg-anim;
`

export const LoadingCircle = styled.circle<{ color: string }>`
  fill: transparent;
  stroke: ${({ color }) => color || '#3651c9'};
  stroke-width: 12;
  stroke-dasharray: 270;
  stroke-dashoffset: 76;
  stroke-linecap: round;
  transform-origin: 50% 50%;
  animation: 1s cubic-bezier(0.55, 0, 0.55, 1) infinite loader-anim;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
`

const LoadingSpinnerComponent: React.FC<LoadingSpinnerProps> = ({
  color = '#3651c9',
  size = 'default',
}) => (
  <LoadingSpinner size={size}>
    <LoadingSVG size={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <LoadingCircle cx="50" cy="50" r="44" color={color} />
    </LoadingSVG>
  </LoadingSpinner>
)

export default LoadingSpinnerComponent
